import type { BatchPreviewAssignLinkProps } from "./batch-preview-assign-link.type";

import { useTranslation } from "react-i18next";

import { BatchPreviewLink } from "../batch-preview-link";
import { getBatchPreviewAssignModelKey } from "../batch-preview.helper";

export const BatchPreviewAssignLink = ({
  customContext,
  type,
  userName: user_name,
  ids,
  icon,
  onClick,
}: BatchPreviewAssignLinkProps) => {
  const { t } = useTranslation();
  const model = getBatchPreviewAssignModelKey(type);

  return (
    <BatchPreviewLink
      customContext={customContext}
      params={{ type, user_name, ids: ids.join(",") }}
      icon={icon === "model" ? model : icon}
      onClick={onClick}
    >
      {t(`global:batchPreview.assign.${model}.link`)}
    </BatchPreviewLink>
  );
};
